var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLinkedinDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.75 5H7.25C6 5 5 6 5 7.125V32.75C5 33.875 6 34.875 7.25 34.875H32.75C34 34.875 35 33.875 35 32.75V7.125C35 6 34 5 32.75 5ZM13.875 30.5H9.5V16.25H13.875V30.5ZM11.75 14.25C10.375 14.25 9.125 13.125 9.125 11.625C9.125 10.125 10.25 9 11.75 9C13.125 9 14.375 10.125 14.375 11.625C14.375 13.125 13.125 14.25 11.75 14.25ZM30.625 30.375H26.25V23.375C26.25 21.75 26.25 19.5 23.875 19.5C21.5 19.5 21.25 21.375 21.25 23.125V30.25H16.875V16.25H21V18.125H21.125C21.75 17 23.25 15.75 25.375 15.75C29.875 15.75 30.75 18.75 30.75 22.625V30.375H30.625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLinkedinDark);
export default __webpack_public_path__ + "static/media/ic-linkedin-dark.d3312d946295315a6a7af0ca9174619f.svg";
export { ForwardRef as ReactComponent };